import { slideDown, slideUp, isVisible } from 'slide-anim';
import attrs from 'attrs';
import ready from "@/scripts/helpers/dom/ready";
import { accordion } from "@/modules/accordion";
import video from "@/modules/lazyframe";
import { initLazyBackgrounds } from "@/scripts/helpers/lazy.js"
import MicroModal from 'micromodal';
import Cookies from 'js-cookie';
import { Slicker } from '@rooi/slicker/esm2015/index';
import { clickTracker, sendMetricAsync } from "@/scripts/helpers/clickTracker";
import cookiePopup from "@/modules/popup-cookie";


const loaderId = 'modal-loader';
const ACTIVE = "is-active";
const formImageCorner = document.querySelector('.form-preview__decoration');
const reviewSlider = document.querySelector('.service-review--slider');
const guideSlider = document.querySelector('.js-operation-principle-slider');

if(formImageCorner) {
  formImageCorner.addEventListener('click', event => {
    const ctaButton = document.querySelector('.intro-section-centered-content .button');
    ctaButton.click();
  });
};

if (reviewSlider) {
  const reviewSliderInit = new Slicker(reviewSlider, {
    dots: false,
    arrows: false,
    infinite: false,
    initialSlide: 0,
    speed: 0,
    autoplaySpeed: 5000,
    fade: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    draggable: false,
    autoplay: true,
    adaptiveHeight: false,
  })
};

if (guideSlider) {
  const slicker = new Slicker(guideSlider, {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    initialSlide: 1
  })
};


const handleFormPreviewDescription = () => {
  if(!document.querySelector('#form-preview-description-trigger')) return;
  const trigger = document.getElementById("form-preview-description-trigger");
  const description = document.getElementById("form-preview-description");
  const introFooter = document.querySelector(".page-section__footer");

  trigger.addEventListener("click", function() {
    if (!isVisible(description)) {
      slideDown(description);
      introFooter.style.background = "linear-gradient(180deg, rgba(16, 16, 20, 0) 0%, #101014 100%)";
      trigger.innerHTML = 'Hide details'
      trigger.classList.add(ACTIVE);
    } else {
      trigger.innerHTML = 'Show details'
      trigger.classList.remove(ACTIVE);
      introFooter.style.background = "transparent";
      slideUp(description);
    }
  });
};

const handleTabs = () => {
  let tabs = document.querySelectorAll(".content-tabs__tab");
  let tabContent = document.querySelectorAll(".content-tabs__panel");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {
      tabs.forEach(item => {
        item.classList.remove(ACTIVE);
      });
      this.classList.add(ACTIVE);
      let tabName = this.getAttribute("data-tab");
      selectTabContent(tabName);
    });
    function selectTabContent(tabName) {
      tabContent.forEach(item => {
        item.classList.contains(tabName)
          ? item.classList.add(ACTIVE)
          : item.classList.remove(ACTIVE);
      });
    }
  });
};

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const square = entry.target.querySelectorAll('.circle-chart__circle--negative');
    if (entry.isIntersecting) {
      square[0].classList.add('circle-chart__circle');
      square[1].classList.add('circle-chart__circle');
	  return;
    }
    square[0].classList.remove('circle-chart__circle');
    square[1].classList.remove('circle-chart__circle');
  });
});
if(document.querySelector('.form-action-decoration')) {
  observer.observe(document.querySelector('.form-action-decoration'));
};

const startLoading = () => {
  const modal = document.getElementById(loaderId);

  if (!modal) {
    const modalElement = document.createElement('div');

    attrs(modalElement, {
      class: ['modal modal--loader with-transparent-overlay'],
      id: loaderId,
      'aria-hidden': true,
    });

    modalElement.insertAdjacentHTML("beforeend", `<div class="modal__overlay" tabindex="-1" data-micromodal-close="data-micromodal-close">
        <div class="loader" style="display: block">
          <svg id="colored--48--loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="100%" height="100%">
            <g fill="none" fill-rule="evenodd">
                <path d="M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24"></path>
                <path fill="#F68F1E" d="M17.573 45.171c-2.08-.622-4.09-1.504-5.938-2.672A24.675 24.675 0 0 1 6.7 38.193a24.41 24.41 0 0 1-3.491-5.583c-.88-2.03-1.427-4.192-1.727-6.393a24.985 24.985 0 0 1 .202-6.654c.43-2.191 1.124-4.339 2.139-6.346A25.274 25.274 0 0 1 7.73 7.736a25.444 25.444 0 0 1 5.363-4.129c1.989-1.1 4.144-1.887 6.366-2.408C21.698.734 23.995.596 26.285.74c2.282.224 4.549.711 6.703 1.551a25.525 25.525 0 0 1 5.994 3.448 26.054 26.054 0 0 1 4.758 5.066c1.319 1.925 2.348 4.044 3.1 6.265.714 2.239 1.063 4.578 1.155 6.93a2.001 2.001 0 0 1-3.998.157 7.124 7.124 0 0 1-.002-.157c-.01-1.965-.218-3.935-.744-5.842-.564-1.891-1.36-3.72-2.42-5.406a22.689 22.689 0 0 0-3.912-4.502 22.48 22.48 0 0 0-5.08-3.188c-1.848-.803-3.815-1.304-5.821-1.584a22.966 22.966 0 0 0-6.072.173c-1.997.392-3.956 1.017-5.79 1.94a23.274 23.274 0 0 0-5.01 3.56 23.401 23.401 0 0 0-3.78 4.892c-1.008 1.816-1.727 3.782-2.21 5.811-.427 2.043-.556 4.145-.43 6.242.205 2.087.643 4.16 1.407 6.131a23.568 23.568 0 0 0 3.147 5.49 24.022 24.022 0 0 0 4.633 4.366c1.762 1.21 3.7 2.154 5.732 2.848 2.049.656 4.19.977 6.35 1.069-2.16-.009-4.326-.247-6.422-.829z"></path>
                <path fill="#F68F1E" d="M17.573 45.171c-2.08-.622-4.09-1.504-5.938-2.672A24.675 24.675 0 0 1 6.7 38.193a24.41 24.41 0 0 1-3.491-5.583c-.88-2.03-1.427-4.192-1.727-6.393a24.985 24.985 0 0 1 .202-6.654c.43-2.191 1.124-4.339 2.139-6.346A25.274 25.274 0 0 1 7.73 7.736a25.444 25.444 0 0 1 5.363-4.129c1.989-1.1 4.144-1.887 6.366-2.408C21.698.734 23.995.596 26.285.74c2.282.224 4.549.711 6.703 1.551a25.525 25.525 0 0 1 5.994 3.448 26.054 26.054 0 0 1 4.758 5.066c1.319 1.925 2.348 4.044 3.1 6.265.714 2.239 1.063 4.578 1.155 6.93a2.001 2.001 0 0 1-3.998.157 7.124 7.124 0 0 1-.002-.157c-.01-1.965-.218-3.935-.744-5.842-.564-1.891-1.36-3.72-2.42-5.406a22.689 22.689 0 0 0-3.912-4.502 22.48 22.48 0 0 0-5.08-3.188c-1.848-.803-3.815-1.304-5.821-1.584a22.966 22.966 0 0 0-6.072.173c-1.997.392-3.956 1.017-5.79 1.94a23.274 23.274 0 0 0-5.01 3.56 23.401 23.401 0 0 0-3.78 4.892c-1.008 1.816-1.727 3.782-2.21 5.811-.427 2.043-.556 4.145-.43 6.242.205 2.087.643 4.16 1.407 6.131a23.568 23.568 0 0 0 3.147 5.49 24.022 24.022 0 0 0 4.633 4.366c1.762 1.21 3.7 2.154 5.732 2.848 2.049.656 4.19.977 6.35 1.069-2.16-.009-4.326-.247-6.422-.829z"></path>
            </g>
          </svg>
        </div>
      </div>`);

    document.body.appendChild(modalElement);
    MicroModal.show(loaderId);
  }
};

const finishLoading = () => {
  const modal = document.getElementById(loaderId);

  if (modal) {
    modal.remove();
  }
};

const initRatingVote = () => {
  const triggers = document.querySelectorAll('.rating--form-preview .rating__star');
  const votesElement = document.querySelectorAll('.rating--form-preview .js-rating-votes-value')[0];
  const tokenTag = document.querySelectorAll('[name=csrf-token]')[0];

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function() {
      const parent = trigger.parentNode;
      const value = Array.from(triggers).indexOf(trigger) + 1;

      const formIdElement = document.querySelectorAll('.page-section--intro [data-formid]')[0];
      const formId = formIdElement.getAttribute('data-formid');
      const token = tokenTag.getAttribute('content');

      const alreadyVoted = !!Cookies.get(`form-rating-${formId}`);

      if (alreadyVoted) return;

      parent.classList.add('has-voted');

      triggers.forEach(t => {
        t.classList.remove('is-filled');
        t.classList.remove('is-half-filled');
      });

      for (let i = 0; i < Number(value); i++) {
        triggers[i].classList.add('is-filled');
      }
 

      fetch('/fillable-form/update-rating', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': token,
        },
        body: JSON.stringify({
          id: formId,
          stars: value,
        }),
        cache: 'default'
      })
        .then(response => response.json())
        .then(() => {
          Cookies.set(`form-rating-${formId}`, value);

          if (!!votesElement) {
            votesElement.textContent = (Number(votesElement.textContent) + 1);
          }
        });
    });
  });
};



const handleRedirectToProduct = () => {
  const triggers = document.querySelectorAll('[data-formid]');
  const tokenTag = document.querySelectorAll('[name=csrf-token]')[0];
  const _token = tokenTag.getAttribute('content');

  let isFetching = false;
  
  const redirectToProduct = (event, trigger) => {
    event.preventDefault();
    if (isFetching) return;
    isFetching = true;

    const formId = trigger.getAttribute('data-formid');
    // const _token = tokenTag.getAttribute('content');
    let buttonText;

    if (trigger.classList.contains("button")) {
      buttonText = trigger.textContent;
    } else {
      buttonText = trigger.querySelector(".button").textContent;
    };
    
    if (window.dataLayer) {
      dataLayer.push({
        'event': 'click_button_cta',
        'label': `${buttonText}`
      });
    };

    startLoading();

    fetch('/fillable-form/forms/get-editor-data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': _token,
      },
      body: JSON.stringify({
        id: formId
      }),
      cache: 'default'
    })
      .then(response => response.json())
      .then(data => {
        if (window.dataLayer) {
          dataLayer.push({'event': 'link_received'});
        }

        window.location = data.data.editorUrl;
      })
      .catch(error => {
        finishLoading();
        isFetching = false;
      })
  }

  triggers.forEach(trigger => {
    trigger.removeEventListener("click", event => redirectToProduct(event, trigger));
    trigger.addEventListener("click",  event => redirectToProduct(event, trigger));
  });
};

handleFormPreviewDescription();
accordion();
handleTabs();

if(document.querySelectorAll('[name=csrf-token]')[0]) {
  handleRedirectToProduct();
  initRatingVote();
}


window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    handleRedirectToProduct();
  }
});

const thirdSection = document.querySelector(".page-section--form-action");
const popupCta = document.querySelector(".popup-cta");
const popupCtaText = document.querySelector(".popup-cta .popup-text");
const popupCtaButton = document.querySelector(".popup-cta .popup-button");


function updatePopupCtaWidth() {
  if (popupCta.classList.contains('popup-cta--v2') || popupCta.classList.contains('popup-cta--v3')) {
    if (window.innerWidth >= 768) {
      const contentWidth = popupCtaText.offsetWidth +140;
      popupCta.style.width = `${contentWidth}px`;
    } else { popupCta.style.width = `248px` };
  } else return
};

function showPopupCta() {
  const scrollThreshold = thirdSection.offsetTop + thirdSection.clientHeight - window.innerHeight;

  popupCta.style.display = 'block';
  window.addEventListener("scroll", () => {
    if (window.scrollY >= scrollThreshold) {
      updatePopupCtaWidth();
      popupCta.classList.add('is-visible');
    } else {
      popupCta.classList.remove('is-visible');
    }
  });
};

function togglePopupCtaButtonText() {
  if (window.innerWidth <= 768) {
      popupCtaButton.textContent = "Use this form for free";
  } else {
      popupCtaButton.textContent = "Start now";
  }
};

function popupCtaInit() {
  if (popupCta) {
    togglePopupCtaButtonText()
    updatePopupCtaWidth();
    showPopupCta();
    
    window.addEventListener("resize", () => {
      updatePopupCtaWidth();
      togglePopupCtaButtonText();
    });
  }
};


ready( () => {
  clickTracker();
  popupCtaInit();
  initLazyBackgrounds();
  video();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});


window.startLoading = startLoading;
window.finishLoading = finishLoading;
window.onpageshow = finishLoading;
window.sendMetricAsync = sendMetricAsync;
